import React, {Fragment} from 'react';

import {useMediaQueries} from 'presentation/pages';
import {useHostName} from 'presentation/hooks';
import {BottomNav, NotredameSidebar, Sidebar} from 'presentation/components';
import {NotredameBottomNav} from 'presentation/components/Navigation/NotredameBottomNav';
import {NavigationMenuProps} from './types';

export function NavigationMenu({hideBottomNav}: NavigationMenuProps) {
	const {isTablet} = useMediaQueries();
	const {isNotredameSaude} = useHostName();

	if (isTablet) {
		if (hideBottomNav) return null;
		return isNotredameSaude ? <NotredameBottomNav /> : <BottomNav />;
	}

	if (isNotredameSaude) return <NotredameSidebar />;

	return (
		<Fragment>
			<Sidebar />
		</Fragment>
	);
}
